// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container global */

.tag-sport     { background-color: #D1F2EB; color: #117864; }
.tag-arts      { background-color: #cdf5ac; color: #080c09; }
.tag-evenement { background-color: #E8DAEF; color: #6C3483; }
.tag-retour    { background-color: #FEF9E7; color: #B7950B; }
.tag-annonce   { background-color: #EAF2F8; color: #2E86C1; }
.tag-jeux      { background-color: #FDF2E9; color: #AF601A; }
.tag-important { background-color: #FDF2E9; color: #ec391a; }

.news-container {
    display: flex;
    gap: 2rem;
    padding: 2rem;
    max-width: 1200px;
    margin: auto;
    flex-wrap: wrap;
  }
  
  /* Colonne gauche (mise en avant) */
  .news-left {
    flex: 0.35 1;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    background: linear-gradient(135deg, #F8FBFF 0%, #2686e6 100%);
    border-radius: 12px;
    padding: 1rem;
  }
  
  .highlight-card-compact {
    display: flex;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.07);
    transition: transform 0.3s ease;
    position: relative;
  }
  
  .highlight-card-compact:hover {
    transform: translateY(-4px);
  }
  
  .highlight-thumb {
    width: 100px;
    height: 100px;
    object-fit: contain;
    flex-shrink: 0;
    padding: 6px;
  }
  
  
  .highlight-info {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.3rem;
  }
  
  .highlight-title {
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
    color: #333;
  }
  
  .highlight-date {
    font-size: 0.8rem;
    color: #888;
  }
  
  .highlight-button {
    margin-top: 0.5rem;
    align-self: flex-start;
    padding: 0.3rem 0.6rem;
    font-size: 0.8rem;
    background-color: #f4f8fc;
    border-radius: 6px;
    text-decoration: none;
    color: #333;
    transition: background 0.3s;
  }
  
  .highlight-button:hover {
    background-color: #e0ecf8;
  }
  
  .highlight-tag {
    font-size: 0.7rem;
    color: #0057b8;
    background-color: #D6E8FF;
    padding: 0.2rem 0.5rem;
    border-radius: 5px;
    width: fit-content;
  }
  
  /* Colonne droite (fil d'actualité) */
  .news-right {
    flex: 0.65 1;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    border-radius: 12px;
    padding: 1rem;
    position: relative;
    background: linear-gradient(135deg, #F8FBFF 0%, #f3bf5e 100%);
  }
  
  .filters {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }
  
  .filters input,
  .filters select {
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
  }
  
  .news-feed {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    position: relative;
    border-left: 3px solid #e0e0e0;
    padding-left: 1rem;
  }
  
  .news-card {
    display: flex;
    gap: 1.5rem;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    position: relative;
  }
  
  .news-card::before {
    content: "";
    width: 12px;
    height: 12px;
    background-color: #0057b8;
    border-radius: 50%;
    position: absolute;
    left: -1.6rem;
    top: 1rem;
  }
  
  .news-image {
    width: 200px;
    height: 140px;
    object-fit: contain;
    padding: 6px;
    flex-shrink: 0;
    box-sizing: border-box;
  }
  
  
  .news-content {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .news-date {
    font-size: 0.8rem;
    color: #999;
  }
  
  .news-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 0.5rem;
  }
  
  .tag {
    padding: 0.25rem 0.6rem;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 500;
  }
  

  
  .no-results {
    text-align: center;
    color: #999;
    font-style: italic;
  }
  /* Ajouté : bouton de réinitialisation + style cohérent pour les filtres */
.reset-button {
    background-color: #ffdddd;
    color: #b30000;
    border: 1px solid #ffcccc;
    border-radius: 6px;
    padding: 0.4rem 0.8rem;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease;
  }
  
  .reset-button:hover {
    background-color: #ffcccc;
    color: #800000;
  }
  
  .filters select,
  .filters input {
    font-family: inherit;
    font-size: 0.95rem;
    border-radius: 6px;
    padding: 0.45rem 0.75rem;
    border: 1px solid #ccc;
    background-color: #fff;
    color: #333;
    transition: border 0.3s ease;
  }
  
  .filters select:focus,
  .filters input:focus {
    border-color: #007bff;
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
  }
  
  .filters {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    align-items: center;
  }

  /* ... tout le CSS existant ... */

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
  font-size: 1rem;
  font-weight: 500;
}

.pagination-controls button {
  background-color: #edf4ff;
  border: 1px solid #c9dfff;
  color: #0057b8;
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.pagination-controls button:hover:not(:disabled) {
  background-color: #d6e8ff;
}

.pagination-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Réinitialise la page courante à 0 à chaque modification de filtre */
.filters input,
.filters select {
  font-family: inherit;
  font-size: 0.95rem;
  border-radius: 6px;
  padding: 0.45rem 0.75rem;
  border: 1px solid #ccc;
  background-color: #fff;
  color: #333;
  transition: border 0.3s ease;
}

  
  /* Responsive styles */
  @media (max-width: 1024px) {
    .news-container {
      flex-direction: column;
      padding: 1rem;
    }
  
    .news-left,
    .news-right {
      flex: 1 1 100%;
    }
  
    .news-card {
      flex-direction: column;
    }
  
    .news-image {
        width: 100%;
        height: 200px;
        object-fit: contain;
        padding: 8px;
      }
  
    .filters {
      flex-direction: column;
      gap: 0.5rem;
    }
  }
  
  @media (max-width: 768px) {
    .highlight-thumb {
      width: 80px;
      height: 80px;
    }
  
    .highlight-info {
      padding: 0.75rem;
      gap: 0.2rem;
    }
  
    .highlight-title {
      font-size: 0.9rem;
    }
  
    .highlight-date {
      font-size: 0.75rem;
    }
  
    .highlight-button {
      font-size: 0.75rem;
      padding: 0.25rem 0.5rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/composant/container/News/NewsPage.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB,iBAAiB,yBAAyB,EAAE,cAAc,EAAE;AAC5D,iBAAiB,yBAAyB,EAAE,cAAc,EAAE;AAC5D,iBAAiB,yBAAyB,EAAE,cAAc,EAAE;AAC5D,iBAAiB,yBAAyB,EAAE,cAAc,EAAE;AAC5D,iBAAiB,yBAAyB,EAAE,cAAc,EAAE;AAC5D,iBAAiB,yBAAyB,EAAE,cAAc,EAAE;AAC5D,iBAAiB,yBAAyB,EAAE,cAAc,EAAE;;AAE5D;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,eAAe;EACjB;;EAEA,mCAAmC;EACnC;IACE,YAAU;IACV,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,6DAA6D;IAC7D,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,oCAAoC;IACpC,0BAA0B;IAC1B,0CAA0C;IAC1C,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;IAC1C,+BAA+B;IAC/B,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,YAAY;EACd;;;EAGA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA,qCAAqC;EACrC;IACE,YAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,6DAA6D;EAC/D;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;EACX;;EAEA;;IAEE,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,sBAAsB;EACxB;;;EAGA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;EAClB;;;;EAIA;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;EACpB;EACA,0EAA0E;AAC5E;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,uDAAuD;EACzD;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;;IAEE,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,4BAA4B;EAC9B;;EAEA;;IAEE,qBAAqB;IACrB,aAAa;IACb,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;EACrB;;EAEA,iCAAiC;;AAEnC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,4BAA4B;AAC9B;;;EAGE,sBAAsB;EACtB;IACE;MACE,sBAAsB;MACtB,aAAa;IACf;;IAEA;;MAEE,cAAc;IAChB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,YAAY;MACd;;IAEF;MACE,sBAAsB;MACtB,WAAW;IACb;EACF;;EAEA;IACE;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,gBAAgB;MAChB,WAAW;IACb;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,uBAAuB;IACzB;EACF","sourcesContent":["/* Container global */\n\n.tag-sport     { background-color: #D1F2EB; color: #117864; }\n.tag-arts      { background-color: #cdf5ac; color: #080c09; }\n.tag-evenement { background-color: #E8DAEF; color: #6C3483; }\n.tag-retour    { background-color: #FEF9E7; color: #B7950B; }\n.tag-annonce   { background-color: #EAF2F8; color: #2E86C1; }\n.tag-jeux      { background-color: #FDF2E9; color: #AF601A; }\n.tag-important { background-color: #FDF2E9; color: #ec391a; }\n\n.news-container {\n    display: flex;\n    gap: 2rem;\n    padding: 2rem;\n    max-width: 1200px;\n    margin: auto;\n    flex-wrap: wrap;\n  }\n  \n  /* Colonne gauche (mise en avant) */\n  .news-left {\n    flex: 0.35;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    background: linear-gradient(135deg, #F8FBFF 0%, #2686e6 100%);\n    border-radius: 12px;\n    padding: 1rem;\n  }\n  \n  .highlight-card-compact {\n    display: flex;\n    background: rgba(255, 255, 255, 0.7);\n    backdrop-filter: blur(8px);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.07);\n    transition: transform 0.3s ease;\n    position: relative;\n  }\n  \n  .highlight-card-compact:hover {\n    transform: translateY(-4px);\n  }\n  \n  .highlight-thumb {\n    width: 100px;\n    height: 100px;\n    object-fit: contain;\n    flex-shrink: 0;\n    padding: 6px;\n  }\n  \n  \n  .highlight-info {\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 0.3rem;\n  }\n  \n  .highlight-title {\n    font-size: 1rem;\n    font-weight: 600;\n    margin: 0;\n    color: #333;\n  }\n  \n  .highlight-date {\n    font-size: 0.8rem;\n    color: #888;\n  }\n  \n  .highlight-button {\n    margin-top: 0.5rem;\n    align-self: flex-start;\n    padding: 0.3rem 0.6rem;\n    font-size: 0.8rem;\n    background-color: #f4f8fc;\n    border-radius: 6px;\n    text-decoration: none;\n    color: #333;\n    transition: background 0.3s;\n  }\n  \n  .highlight-button:hover {\n    background-color: #e0ecf8;\n  }\n  \n  .highlight-tag {\n    font-size: 0.7rem;\n    color: #0057b8;\n    background-color: #D6E8FF;\n    padding: 0.2rem 0.5rem;\n    border-radius: 5px;\n    width: fit-content;\n  }\n  \n  /* Colonne droite (fil d'actualité) */\n  .news-right {\n    flex: 0.65;\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n    border-radius: 12px;\n    padding: 1rem;\n    position: relative;\n    background: linear-gradient(135deg, #F8FBFF 0%, #f3bf5e 100%);\n  }\n  \n  .filters {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n  \n  .filters input,\n  .filters select {\n    padding: 0.5rem;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    font-size: 1rem;\n  }\n  \n  .news-feed {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n    position: relative;\n    border-left: 3px solid #e0e0e0;\n    padding-left: 1rem;\n  }\n  \n  .news-card {\n    display: flex;\n    gap: 1.5rem;\n    background-color: #fff;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    overflow: hidden;\n    position: relative;\n  }\n  \n  .news-card::before {\n    content: \"\";\n    width: 12px;\n    height: 12px;\n    background-color: #0057b8;\n    border-radius: 50%;\n    position: absolute;\n    left: -1.6rem;\n    top: 1rem;\n  }\n  \n  .news-image {\n    width: 200px;\n    height: 140px;\n    object-fit: contain;\n    padding: 6px;\n    flex-shrink: 0;\n    box-sizing: border-box;\n  }\n  \n  \n  .news-content {\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  \n  .news-date {\n    font-size: 0.8rem;\n    color: #999;\n  }\n  \n  .news-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    margin-top: 0.5rem;\n  }\n  \n  .tag {\n    padding: 0.25rem 0.6rem;\n    border-radius: 999px;\n    font-size: 0.75rem;\n    font-weight: 500;\n  }\n  \n\n  \n  .no-results {\n    text-align: center;\n    color: #999;\n    font-style: italic;\n  }\n  /* Ajouté : bouton de réinitialisation + style cohérent pour les filtres */\n.reset-button {\n    background-color: #ffdddd;\n    color: #b30000;\n    border: 1px solid #ffcccc;\n    border-radius: 6px;\n    padding: 0.4rem 0.8rem;\n    font-size: 0.9rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s ease, color 0.2s ease;\n  }\n  \n  .reset-button:hover {\n    background-color: #ffcccc;\n    color: #800000;\n  }\n  \n  .filters select,\n  .filters input {\n    font-family: inherit;\n    font-size: 0.95rem;\n    border-radius: 6px;\n    padding: 0.45rem 0.75rem;\n    border: 1px solid #ccc;\n    background-color: #fff;\n    color: #333;\n    transition: border 0.3s ease;\n  }\n  \n  .filters select:focus,\n  .filters input:focus {\n    border-color: #007bff;\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);\n  }\n  \n  .filters {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n    align-items: center;\n  }\n\n  /* ... tout le CSS existant ... */\n\n.pagination-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 2rem;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.pagination-controls button {\n  background-color: #edf4ff;\n  border: 1px solid #c9dfff;\n  color: #0057b8;\n  padding: 0.4rem 0.8rem;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.pagination-controls button:hover:not(:disabled) {\n  background-color: #d6e8ff;\n}\n\n.pagination-controls button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Réinitialise la page courante à 0 à chaque modification de filtre */\n.filters input,\n.filters select {\n  font-family: inherit;\n  font-size: 0.95rem;\n  border-radius: 6px;\n  padding: 0.45rem 0.75rem;\n  border: 1px solid #ccc;\n  background-color: #fff;\n  color: #333;\n  transition: border 0.3s ease;\n}\n\n  \n  /* Responsive styles */\n  @media (max-width: 1024px) {\n    .news-container {\n      flex-direction: column;\n      padding: 1rem;\n    }\n  \n    .news-left,\n    .news-right {\n      flex: 1 1 100%;\n    }\n  \n    .news-card {\n      flex-direction: column;\n    }\n  \n    .news-image {\n        width: 100%;\n        height: 200px;\n        object-fit: contain;\n        padding: 8px;\n      }\n  \n    .filters {\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .highlight-thumb {\n      width: 80px;\n      height: 80px;\n    }\n  \n    .highlight-info {\n      padding: 0.75rem;\n      gap: 0.2rem;\n    }\n  \n    .highlight-title {\n      font-size: 0.9rem;\n    }\n  \n    .highlight-date {\n      font-size: 0.75rem;\n    }\n  \n    .highlight-button {\n      font-size: 0.75rem;\n      padding: 0.25rem 0.5rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
